import { registerTourProduct } from '../onboardingTourFactory';

/**
 * The final page of the tour.
 *
 * @param {Function} t The function to perform translations with (see `getTranslateFunction()`).
 * @return {object} {steps: [...], novusPagePath: string|false }
 */
const createTour = (t) => {
  return {
    // We don't wish to redirect.
    novusPagePath: false,
    steps: [
      {
        // [No screen focus]
        intro: t(
          'Thanks for taking the tour! If you need a refresher, you can always access it from the menu.'
        ),
        novusTrackingId: 'thanks-for-taking-tour'
      }
    ]
  };
};

export const tourName = 'completedTour';
registerTourProduct(tourName, createTour);



// WEBPACK FOOTER //
// ./src/actions/onboarding/config/completedTour.js